/**
 * Toast/notificación visual reutilizable.
 *
 * Se monta desde `NotificationContext` y se autocierra tras unos segundos.
 */
import { useEffect } from "react";
import "./Notification.scss";

const Notification = ({ notification, onClose }) => {
  useEffect(() => {
    if (notification) {
      const timer = setTimeout(() => {
        onClose();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [notification, onClose]);

  if (!notification) return null;

  return (
    <div
      className={`notification-card ${notification.type || "info"}`}
      role="alert"
    >
      <div className="notification-content">
        <div className="notification-header">
          {notification.icon && (
            <img
              src={notification.icon}
              alt="Notificación"
              className="notification-icon"
            />
          )}
          <h3 className="notification-title">{notification.title}</h3>
          <button
            onClick={onClose}
            className="notification-close"
            aria-label="Cerrar"
          >
            &times;
          </button>
        </div>
        <p className="notification-body">{notification.body}</p>
      </div>
    </div>
  );
};

export default Notification;
